<template>
    <div class="article-terms-exclusions">
        <p>
            We reserve the right to exclude any individual from Our Events and The Network, if we believe that they are
            in violation of any of the conditions in Section 3.
        </p>
        <p>
            If the decision is taken to exclude an individual, we may give some general guidance to that individual as
            to why they have been excluded, although we reserve the right to withhold any details of complaints, we may
            have received from other Swing Renegades Members or the Swing Renegades Team.
        </p>
        <p>
            If an individual is excluded, any remaining subscription they have paid for will be refunded on a Pro Rata
            basis for the days they have remaining. Any subscription awarded as a prize in a competition, or for any
            reason other than an individual purchase, will not be refunded.
        </p>
        <p>We have the full support of our venues in this matter.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleTermsExclusions',
};
</script>
